/* eslint-disable import/no-default-export */
import QuestionsPresenter from './questionsPresenter';
import { Collections } from '../../../../../firebase/firestore/collections';
import { Position } from '../../../../../firebase/firestore/documents/position';
import { useDocumentSnapshot } from '../../../../../firebase/firestore/hooks';
import { Candidate } from '../../../../../firebase/firestore/documents/candidate';

export enum QuestionStateEnum {
  UNDEFINED,
  LOADING,
  READY,
}

export type QuestionState = {
  state: QuestionStateEnum;
  questions: QuestionsPresenter | undefined;
  initialized: boolean;
};

const useFreeFormQuestions = (candidate?: Candidate | undefined, positionId?: string | undefined): QuestionState => {
  // const { selectedCandidate: candidateFromContext } = useSeekerContainerContext();
  // const selectedEngagedCandidate = useSelectedEngagedCandidate();
  // const selectedCandidate = candidateFromContext || selectedEngagedCandidate || candidateFromTopCandidate;
  const position = useDocumentSnapshot<Position>(Collections.POSITIONS, (candidate?.position ?? positionId) || '');

  if (position) {
    if (
      candidate &&
      !candidate.freeFormQuestionResponses?.length &&
      (candidate?.monetized || /* istanbul ignore next */ !position?.freeFormQuestions?.length)
    ) {
      return {
        state: QuestionStateEnum.UNDEFINED,
        questions: undefined,
        initialized: true,
      };
    }

    return {
      state: QuestionStateEnum.READY,
      questions: new QuestionsPresenter(position, candidate),
      initialized: true,
    };
  }

  return {
    state: QuestionStateEnum.LOADING,
    questions: undefined,
    initialized: false,
  };
};

export default useFreeFormQuestions;
